import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../Model/Common/common.service';
import { TransferOrderService } from '../transfer-order.service';
import { SessionService } from '../Util/Session/session.service';
import { PostingOrderService } from '../posting-order.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../Model/Combo/combo.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { AllotmentDetailService } from '../allotment-detail.service';

@Component({
  selector: 'app-transfer-order-form',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgSelectModule],
  templateUrl: './transfer-order-form.component.html',
  styleUrl: './transfer-order-form.component.scss'
})
export class TransferOrderFormComponent {

  isDisabled: boolean = false;
  TransferOrderID = 0;
  IsSubContractor = false;
  ValidEffectiveDate: boolean = false;
  user: any = {}

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private TransferOrder: TransferOrderService,
    private session: SessionService,
    private PostingOrder: PostingOrderService,
    private combo: ComboService,
    private toast: ToastService,
    private allotmentService: AllotmentDetailService
  ) {
    this.IsSubContractor = window.location.pathname.includes('transferordersub');
    this.route.params.subscribe(params => this.TransferOrderID = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
    this.Filter.CREATEDBY = this.user.UserId;
  }

  Vendors: any[] = [];
  CustomerLoad: any[] = [];
  LocationLoad: any[] = [];
  BranchLoad: any[] = [];
  EmployeeLoad: any[] = [];
  EmployeeDesignationLoad: any[] = [];
  ReasonOfTransferLoad: any[] = [];
  Duty: any[] = [];
  Shift: any[] = [];

  Filter = {
    SelectType: 2,
    ID: null as any,
    TRANSACTIONDATE: null as any,
    BranchID: null as any,
    EMPLOYEEID: null,
    SelectedEmployee: '',

    FROM_CUSTOMERID: null as any,
    FROM_SITEID: null as any,

    FROM_SITE: '',
    pdesignation: '',
    pduty: '',
    pshift: '',
    FROM_CUSTOMER: '',

    TO_CUSTOMERID: null as any,
    TO_SITEID: null,
    DESIGNATIONID: null,
    DUTYID: null,
    SHIFTID: null,

    ALLOTMENTID: null,
    FROMDATE: null as any,
    TODATE: null,
    REASONID: null,
    REMARKS: null,
    CREATEDBY: this.user.UserId,
    Client: null as any,
    DesignationName: '',
    JoiningDate: null as any,
    VendorId: 0,
    VendorName: '',

    FromDesignationID: null,
    FromDutyID: null,
    FromShiftID: null,
    FromVendorID: null,
  }

  async ngOnInit() {
    this.GetTodaysDate();
    this.ESS_FillComboOAS('Vendor');
    await this.ComboLoad('Branch');
    this.FillCombo("Transfer Order", 0, 4);
    if (this.TransferOrderID > 0) {
      this.GetData();
    }
  }

  async GetData() {
    this.isDisabled = true;
    this.PostingOrder.PostingOrder({
      PostingOrderID: this.TransferOrderID
    }).subscribe({
      next: async (response) => {
        // debugger
        const data = response.Table[0];
        this.Filter.ALLOTMENTID = data.PostingOrderID;
        this.Filter.ID = data.PostingOrderNumber;
        this.Filter.TRANSACTIONDATE = data.TransactionDate.split('/')[2] + '-' + data.TransactionDate.split('/')[1] + '-' + data.TransactionDate.split('/')[0]
        this.Filter.FROMDATE = data.EffectDateFrom.split('/')[2] + '-' + data.EffectDateFrom.split('/')[1] + '-' + data.EffectDateFrom.split('/')[0]
        this.Filter.BranchID = data.BranchID;
        await this.ComboLoad('Client');
        this.IsSubContractor ? await this.ESS_EmployeeSubcontracterSelect() : await this.FillCombo('Transfer Order Branch', this.Filter.BranchID, 0)
        // this.FillCombo('Transfer Order Branch', this.Filter.BranchID, 0)
        this.Filter.EMPLOYEEID = data.EmployeeID;
        this.Filter.JoiningDate = data.JoiningDate;
        // this.GetDataOnEmployeeLoad(this.Filter.EMPLOYEEID);

        this.Filter.FROM_CUSTOMER = data.PCustomerName;
        this.Filter.FROM_SITE = data.PSiteName;
        this.Filter.FROM_CUSTOMERID = data.PCustomerId;
        this.Filter.FROM_SITEID = data.PSiteId;
        this.Filter.FromDesignationID = data.FromDesignationID;
        this.Filter.pdesignation = data.FromDesignationName;

        this.Filter.pduty = data.FromDutyName;
        this.Filter.FromDutyID = data.FromDutyId

        this.Filter.pshift = data.FromShiftName;
        this.Filter.FromShiftID = data.FromShiftID;

        this.Filter.SelectedEmployee = data.EmployeeName;
        this.Filter.TO_CUSTOMERID = data.CustomerID;
        await this.ComboLoad('Site');
        this.Filter.TO_SITEID = data.SiteID;
        await this.ComboLoad('Designation');
        this.Filter.DESIGNATIONID = data.DesignationID;
        await this.ComboLoad('Duty');
        this.Filter.DUTYID = data.DutyID;
        await this.ComboLoad('ShiftLoadBasedOnDesignationDuty');
        this.Filter.SHIFTID = data.ShiftId;
        const reason = this.ReasonOfTransferLoad.find(x => x.ReasonName === data['Reason']);
        this.Filter.REASONID = reason.ReasonMasterID;
        this.Filter.REMARKS = data.Remarks;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDataOnEmployeeLoad() {
    this.isDisabled = true;
    this.allotmentService.EmployeeAllotmentDetails({
      EmpMasterID: this.Filter.EMPLOYEEID,
    }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.Filter.SelectedEmployee = '';
          this.Filter.FROM_SITEID = '';
          this.Filter.FROM_CUSTOMERID = null;
          this.Filter.DESIGNATIONID = null;
          this.Filter.DUTYID = null;
          this.Filter.SHIFTID = null;
          this.Filter.pdesignation = '';
          this.Filter.pduty = '';
          this.Filter.pshift = '';
          this.Filter.VendorName = '';
          this.Filter.VendorId = 0;
          this.Filter.FromDesignationID = null;
          this.Filter.FromShiftID = null;
          this.Filter.FromDutyID = null;
          this.Filter.FROM_CUSTOMER = '';
          this.Filter.FROM_SITE = ''
        } else {
          const data = response.Table[0];
          this.Filter.SelectedEmployee = data.FullName;
          this.Filter.FROM_SITE = data.FromSiteName;
          this.Filter.FROM_CUSTOMER = data.FromClientName;
          this.Filter.DesignationName = data.FromDesignationName;
          this.Filter.FROM_CUSTOMERID = data.From_CustomerID;
          this.Filter.FROM_SITEID = data.From_SiteID;
          this.Filter.JoiningDate = data.JoiningDate;
          this.Filter.pdesignation = data.FromDesignationName;
          this.Filter.pduty = data.FromDutyName;
          this.Filter.pshift = data.FromShiftName;
          this.Filter.VendorId = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EMPLOYEEID).VendorId;
          this.Filter.VendorName = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EMPLOYEEID).VendorName;
          this.Filter.FromDesignationID = data.FromDesignationID;
          // this.Filter.DesignationName = data.FromDesignationName;
          this.Filter.FromDutyID = data.FromDutyID;
          this.Filter.FromShiftID = data.FromShiftID
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FillCombo(Combotype: String, branchID: any, id1: any) {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.PostingOrder.FillCombo({
        'SelectType': Combotype,
        'BranchID': branchID,
        'UserID': 0,
        'ID1': id1,
        'Code1': '',
        'ID2': 0,
        'Code2': '',
        'ID3': '',
        'Code3': '',
        'EmpType': '',
      }).subscribe({
        next: (response) => {
          if (Combotype === 'Branch Master') {
            this.BranchLoad = response.Table;
          } else if (Combotype === 'Transfer Order' && id1 == 2) {
            this.EmployeeDesignationLoad = response.Table
          } else if (Combotype === 'Transfer Order' && id1 == 3) {
            this.Duty = response.Table;
          } else if (Combotype === 'Transfer Order' && id1 == 4) {
            this.ReasonOfTransferLoad = response.Table
          } else if (Combotype === 'Allotment Shift Master' && id1 == 0) {
            this.Shift = response.Table
          } else if (Combotype === 'ClientGroupIDByBranch') {
            this.CustomerLoad = response.Table;
          } else if (Combotype === 'Transfer Order Branch') {
            this.EmployeeLoad = response.Table;
            console.log(this.EmployeeLoad);
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  async ESS_EmployeeSubcontracterSelect() {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.PostingOrder.ESS_EmployeeSubcontracterSelect({
        SubType: 'A',
        SelectType: 'EW'
      }).subscribe({
        next: async (response) => {
          this.EmployeeLoad = [...response.Table, response.Table.map((e: any) => e.Code = (e.FirstName + ' ' + e.LastName))];
          // debugger
          // const employee  = this.EmployeeLoad.find((item: any) => item.EmpMasterID == )
          // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          //   dtInstance.destroy();
          //   this.dtTrigger.next(null);
          // });
          resolve(true);
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    if (Combotype === 'Client') {
      this.Filter.TO_CUSTOMERID = null;
      this.CustomerLoad = [];
      this.Filter.TO_SITEID = null;
      this.LocationLoad = []
      this.Filter.DESIGNATIONID = null;
      this.EmployeeDesignationLoad = [];
      this.Filter.DUTYID = null;
      this.Duty = [];
      this.Filter.SHIFTID = null;
    } else if (Combotype === 'Site') {
      this.Filter.TO_SITEID = null;
      this.LocationLoad = []
      this.Filter.DESIGNATIONID = null;
      this.EmployeeDesignationLoad = [];
      this.Filter.DUTYID = null;
      this.Duty = [];
      this.Filter.SHIFTID = null;
    } else if (Combotype == 'Designation'){
      this.Filter.DESIGNATIONID = null;
      this.EmployeeDesignationLoad = [];
      this.Filter.DUTYID = null;
      this.Duty = [];
      this.Filter.SHIFTID = null;
    } else if (Combotype == 'Duty'){
      this.Filter.DUTYID = null;
      this.Duty = [];
      this.Filter.SHIFTID = null;
    } else if (Combotype == 'ShiftLoadBasedOnDesignationDuty'){
      this.Filter.SHIFTID = null;
    }

    return new Promise((resolve, reject) => {
      this.combo.ComboLoad({
        'Combotype': Combotype,
        'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.BranchID : 0,
        'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.TO_CUSTOMERID : 0,
        'SiteId': (Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.TO_SITEID : 0,
        'DesignationId': (Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.DESIGNATIONID : 0,
        'DutyId': (Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.DUTYID : 0,
        'EmpType': 'Front'
      }).subscribe({
        next: (response) => {
          if (Combotype == 'ShiftLoadBasedOnDesignationDuty') {
            this.Shift = response.ComboLoad;
            this.Filter.SHIFTID = null;
          } else if (Combotype == 'Designation') {
            this.EmployeeDesignationLoad = response.ComboLoad
          } else if (Combotype == 'Duty') {
            this.Duty = response.ComboLoad;
            this.Filter.DUTYID = null;
          } else if (Combotype == 'Branch') {
            this.BranchLoad = response.ComboLoad
          } else if (Combotype == 'Client') {
            this.CustomerLoad = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.LocationLoad = response.ComboLoad;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  GetTodaysDate() {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    this.Filter.TRANSACTIONDATE = formattedDate;
    this.Filter.FROMDATE = formattedDate;
  }

  ESS_FillComboOAS(Type: String) {
    this.isDisabled = true;
    return this.PostingOrder.ESS_FillComboOAS({ 'SelectType': Type }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (Type == "Vendor") {
            this.Vendors = response.Table;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to save?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.InsertUpdate();
      }
    }).catch(() => { });
  }

  async InsertUpdate() {
    console.log(this.ValidEffectiveDate);
    await this.ValidateEffectiveDate(this.Filter.EMPLOYEEID);
    if (this.ValidEffectiveDate) {
      return;
    }
    this.Filter.SelectType = this.TransferOrderID > 0 ? 21 : 2;
    this.Filter.TODATE = this.Filter.FROMDATE;
    this.isDisabled = true;
    this.TransferOrder.SaveTransferOrder(this.Filter).subscribe({
      next: (response: any) => {
        console.log(response);
        if (response.STATUS == 1) {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              // this.activeModal.close(true)
              this.IsSubContractor ? this.router.navigate(['/allocation/transferordersub']) : this.router.navigate(['/allocation/transferorder']);
            }
          });
        } else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;

      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ValidateEffectiveDate(empId: any) {
    this.isDisabled = true;
    this.ValidEffectiveDate = false;
    return new Promise((resolve, reject) => {
      this.PostingOrder.GetDataOnComboLoad({
        SelectType: "Posting Order Date",
        ID: empId,
      }).subscribe({
        next: (response) => {
          // console.log(response.Table[0].From_Date);
          // console.log(this.Filter.JoiningDate);
          // console.log(this.Filter.FROMDATE);
          // console.log(response.Table[0].From_Date);

          let joiningDate = new Date(this.Filter.JoiningDate.split('/')[2] + '-' + this.Filter.JoiningDate.split('/')[1] + '-' + this.Filter.JoiningDate.split('/')[0]);
          let transferDate = new Date(this.Filter.FROMDATE);
          let checkdate = response.Table[0].From_Date;
          let checkdateformatted = new Date(checkdate.split('/')[2] + '-' + checkdate.split('/')[1] + '-' + checkdate.split('/')[0]);

          // console.log(joiningDate);
          // console.log(transferDate);
          // console.log(checkdateformatted);

          let designation = this.EmployeeDesignationLoad.find((e: any) => e.DesignationMasterID == this.Filter.DESIGNATIONID).DesignationName;
          let duty = this.Duty.find((e: any) => e.DutyMasterID == this.Filter.DUTYID).DutyName;
          let shift = this.Shift.find((e: any) => e.ShiftMasterID == this.Filter.SHIFTID).ShiftTitle;

          if ((this.Filter.FROM_CUSTOMERID == this.Filter.TO_CUSTOMERID) && (this.Filter.FROM_SITEID == this.Filter.TO_SITEID) && (designation.toLowerCase() == this.Filter.pdesignation.toLowerCase()) && (duty.toLowerCase() == this.Filter.pduty.toLowerCase()) && (shift.toLowerCase() == this.Filter.pshift.toLowerCase())) {
            this.toast.show({ message: "Can't transfer to the Same Location with same designation, duty and shift", type: toastTypeEnum.warning });
            this.ValidEffectiveDate = true;
            return;
          }

          if (joiningDate > transferDate) {
            this.toast.show({ message: `Transfer Order Date should be greater than equal to ${this.Filter.JoiningDate}`, type: toastTypeEnum.warning });
            this.ValidEffectiveDate = true;
            return;
          }

          if (response.Table.length > 0) {
            if (transferDate < checkdateformatted) {
              this.toast.show({ message: `Transfer Order Date should be greater than equal to ${checkdate}`, type: toastTypeEnum.warning });
              this.ValidEffectiveDate = true;
              return;
            }
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          reject(error);
        },
      });
    })
  }

  async OnBranchChange() {
    this.EmployeeLoad = [];
    this.ComboLoad('Client');
    // this.FillCombo('ClientGroupIDByBranch');
    this.IsSubContractor ? await this.ESS_EmployeeSubcontracterSelect() : await this.FillCombo('Transfer Order Branch', this.Filter.BranchID, 0)
    this.Filter.EMPLOYEEID = null;
    this.Filter.SelectedEmployee = '';
  }

  LoadEmployeeDesignation() {
    const designation = this.EmployeeDesignationLoad.find(x => x.DesignationName === this.Filter.DesignationName);
    if (designation) {
      this.Filter.DESIGNATIONID = designation.DesignationMasterID;
    } else {
      this.Filter.DESIGNATIONID = null;
    }
  }

  TransferOrderReport() {
    this.isDisabled = true;
    this.TransferOrder.TransferOrderPrint({
      ID: this.TransferOrderID,
      BranchID: this.Filter.BranchID
    }).subscribe({
      next: (response) => {
        window.open(response.FullFileName, '_blank')
      },
      complete: () => {
        this.isDisabled = false;
      },
    });
  }

  cancel() {
    this.IsSubContractor ? this.router.navigate(['/allocation/transferordersub']) : this.router.navigate(['/allocation/transferorder']);
  }
}
